import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, GoogleButton } from "./AuthShell";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back!");
      const dest = loc.state?.from || (user.role === "admin" ? "/admin" : user.role === "organizer" ? "/organizer" : "/dashboard");
      nav(dest, { replace: true });
    } catch (e2) {
      setError(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Log In" subtitle="Welcome back to YourRaceFinder">
      <form onSubmit={submit} className="space-y-4">
        {error && <div className="bg-red-50 text-red-600 text-sm p-3 rounded-lg" data-testid="login-error">{error}</div>}
        <div>
          <label className="text-sm font-semibold text-slate-700">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
            className="mt-1 w-full border border-slate-300 rounded-lg px-4 py-3 focus:border-[#22d3ee] outline-none" />
        </div>
        <div>
          <div className="flex justify-between">
            <label className="text-sm font-semibold text-slate-700">Password</label>
            <Link to="/forgot-password" className="text-sm text-[#06b6d4] hover:underline">Forgot password?</Link>
          </div>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
            className="mt-1 w-full border border-slate-300 rounded-lg px-4 py-3 focus:border-[#22d3ee] outline-none" />
        </div>
        <button disabled={busy} type="submit" data-testid="login-submit"
          className="w-full bg-[#0a1420] text-white font-bold py-3 rounded-lg hover:bg-[#22d3ee] hover:text-[#0a1420] transition-colors disabled:opacity-60">
          {busy ? "Signing in…" : "Log In"}
        </button>
      </form>
      <div className="flex items-center gap-3 my-6"><div className="flex-1 h-px bg-slate-200" /><span className="text-xs text-slate-400">OR</span><div className="flex-1 h-px bg-slate-200" /></div>
      <GoogleButton />
      <p className="text-center text-sm text-slate-500 mt-6">Don't have an account? <Link to="/register" className="text-[#06b6d4] font-semibold hover:underline">Sign Up</Link></p>
    </AuthShell>
  );
}
